import { getCookieValue } from './cookie';

export const CookieConsent = {
  Necessary: 'C0001',
  ProfilationAnalytics: 'C0002',
  Functional: 'C0003',
  ProfilationTargeting: 'C0004',
} as const;

export const OPTANON_CONSENT_COOKIE_NAME = 'OptanonConsent';

export type CookieConsentType =
  (typeof CookieConsent)[keyof typeof CookieConsent];

export function getOneTrustCookieConsent(cookieConsentType: CookieConsentType) {
  // example OptanonConsent = isGpcEnabled=1&datestamp=Fri+Aug+08+2025+10%3A15%3A19+GMT%2B0200+(Ora+legale+dell%E2%80%99Europa+centrale)&version=202409.2.0&browserGpcFlag=1&isIABGlobal=false&hosts=&consentId=89ef97e0-f00d-4b9c-a1c3-c10fd42e93de&interactionCount=2&isAnonUser=1&landingPath=NotLandingPage&groups=C0003%3A1%2CC0001%3A1%2CC0002%3A1%2CC0004%3A1&intType=4

  const optanonConsent = getCookieValue(OPTANON_CONSENT_COOKIE_NAME);
  const encodedOptanonConsentGroups = optanonConsent
    ?.split('&')
    .find((part) => part.startsWith('groups='));

  const optanonConsentGroups =
    encodedOptanonConsentGroups != null
      ? decodeURIComponent(encodedOptanonConsentGroups)
      : null;

  const optanonConsentGroupsValue = optanonConsentGroups?.split('=')[1];

  const listOfConsents = optanonConsentGroupsValue?.split(',') ?? [];

  const selectedConsent = listOfConsents
    .map((consent) => consent.split(':'))
    .find((consent) => consent[0] === cookieConsentType);

  const selectedConsentValue = selectedConsent?.[1];

  return selectedConsentValue === '1';
}
